import Modal from "@common/Modal";

interface PartnerInfoModalProps {
    handleClose: () => void;
    show: boolean;
    content: {
        title?: string;
        data?: { title: string; description: string }[];
    };
}

export default function PartnerInfoModal(props: PartnerInfoModalProps) {
    const { handleClose, show, content } = props;

    return (
        <div className="model-outer upload-error-popup addon-popup">
            <Modal show={show} handleClose={handleClose}>
                <div className="modal-body">
                    <h2>{content?.title ?? ""}</h2>
                    {content?.data && content.data.length > 0 ? (
                        content.data.map((item: any, index: number) => (
                            <div key={index} className="modal-item">
                                <h3 className="modal-item-title">{index + 1}. {" " + item.titile}</h3>
                                <p className="modal-item-description m-md-l">{item.description}</p>
                            </div>
                        ))
                    ) : (
                        <p className="modal-no-data">No data available</p>
                    )}
                </div>
            </Modal>
        </div>
    );
}
